import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <p className="font-serif text-xl text-brand-black">Family Court Guide</p>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-gold hover:text-brand-black mb-6">
          <ArrowLeft className="h-4 w-4" /> Back to the form
        </Link>
        <h1 className="font-serif text-3xl text-brand-black mb-2">Privacy notice</h1>
        <p className="text-sm text-brand-darkgrey mb-6">Effective Date: 06/08/2025</p>
        <div className="space-y-4 text-sm text-brand-darkgrey leading-relaxed">
          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">Introduction</h2>
            <p>
              The Family Court Name (“we”, “us”, or “our”) is committed to protecting the privacy and
              personal information of individuals who use our website. This Privacy Policy outlines how we
              collect, use, disclose, and safeguard your information when you visit our website.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <h3 className="font-semibold text-brand-black">a. Personal Information You Provide</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Name, email address, phone number, or other contact details submitted via forms.</li>
              <li>Information submitted through online filings, applications, or requests.</li>
            </ul>
            <h3 className="font-semibold text-brand-black">b. Automatically Collected Information</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>IP address</li>
              <li>Browser type and version</li>
              <li>Pages visited and time spent on the site</li>
              <li>Date and time of access</li>
            </ul>
            <p>This data is collected for analytics, security, and site optimization purposes.</p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Provide you with information or services requested</li>
              <li>Respond to inquiries or applications</li>
              <li>Improve our website’s usability and performance</li>
              <li>Ensure the security and integrity of our systems</li>
            </ul>
            <p>We do not sell, rent, or trade your personal information to third parties.</p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">3. Disclosure of Information</h2>
            <p>We may disclose your information:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>As required by law, regulation, or court order</li>
              <li>To authorized law enforcement or government officials</li>
              <li>To third-party service providers who assist us in operating our website (bound by confidentiality obligations)</li>
            </ul>
            <p>Any such disclosures will be made in compliance with applicable privacy laws.</p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">4. Cookies and Tracking Technologies</h2>
            <p>
              We may use cookies and similar technologies to improve your browsing experience. These are
              small text files stored on your device.
            </p>
            <p>
              You can adjust your browser settings to refuse cookies or alert you when they are being used.
              Note that some site features may not function properly without cookies.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">5. Data Security</h2>
            <p>
              We implement appropriate technical and administrative security measures to protect your
              information from unauthorized access, disclosure, or misuse. However, no system is entirely
              secure. Please use discretion when submitting personal information online.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">6. Third-Party Links</h2>
            <p>
              Our website may contain links to other websites. We are not responsible for the privacy
              practices or content of these third-party sites. Please review their privacy policies before
              sharing any personal information.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">7. Your Rights</h2>
            <p>Depending on your jurisdiction, you may have the right to:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Access personal data we hold about you</li>
              <li>Request correction or deletion of your data</li>
              <li>Object to or restrict processing of your data</li>
            </ul>
            <p>To exercise these rights, please contact us using the information below.</p>
          </section>

          <section className="space-y-2">
            <h2 className="font-serif text-xl text-brand-black">8. Contact Us</h2>
            <p>
              If you have questions or concerns about this Privacy Policy or our practices, please contact:
            </p>
            <p>
              Family Court Guide<br />
              Brian Hudson Ltd<br />
              Email: <a href="mailto:bh@familycourt.guide" className="text-brand-gold underline underline-offset-2">bh@familycourt.guide</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
